import { render, staticRenderFns } from "./Item.vue?vue&type=template&id=7c7b7814&"
import script from "./Item.vue?vue&type=script&lang=ts&"
export * from "./Item.vue?vue&type=script&lang=ts&"
import style0 from "./Item.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ButtonCircle: require('/tmp/build_71ad00c4/src/components/button/Circle.vue').default})
